import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { action } from 'mobx';
import { observable } from 'mobx';
import { FormGroup, Button, Intent } from "@blueprintjs/core";
import Toast from 'helpers/toaster';
import FormDrawer from 'components/FormDrawer';
import { FormSection, Choice, FieldError, MoreOptions } from 'components/FormBits';
import SupplierAutocomplete from 'components/SupplierAutocomplete';
import ProductCategoryAutocomplete from 'components/ProductCategoryAutocomplete';
import { currency, currencySymbol } from 'helpers/currency';
import ProductServiceXeroModal from 'components/ProductsServices/ProductServiceXeroModal';

const isBlank = (value) => value === undefined || value === null || String(value).trim() === '';

const ITEM_TYPES = [
  { value: 'Materials', label: 'Material', hint: 'A part or product you supply' },
  { value: 'Labor', label: 'Labor', hint: 'Work charged by the hour' },
];

// Bring a field with an error into view and put the cursor in it.
const focusField = (id) => {
  setTimeout(() => {
    const field = document.getElementById(id);
    if (!field) return;
    field.scrollIntoView({ block: 'center', behavior: 'smooth' });
    field.focus({ preventScroll: true });
  }, 0);
};

@inject('productServiceStore', 'quickbooksStore','viewStore','xeroStore') @observer
class ProductServiceModal extends Component {
  @observable isItemsXeroDialogVisible = false;
  @observable errors = {};

  componentDidMount() {
    this.props.quickbooksStore.loadQuickbooksItems();
    this.props.xeroStore.loadXeroItems();
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.errors = {};
    }
  }

  clearError(key) {
    if (this.errors[key]) {
      this.errors = { ...this.errors, [key]: null };
    }
  }

  // The name is required: say so under the field and put the cursor there.
  validateName(object) {
    if (isBlank(object.name)) {
      this.errors = { ...this.errors, name: 'Enter a name, e.g. 16x25x1 air filter.' };
      focusField('product-service-name');
      return false;
    }
    this.clearError('name');
    return true;
  }

  onCloseItemsXeroDialog() {
    this.isItemsXeroDialogVisible = false;
  }

  onSucessUpdateItemsXero() {
    this.isItemsXeroDialogVisible = true;
  }

  handleCloseDailog() {
    // clearing object
    this.props.productServiceStore.productService.object = {}
    this.props.onClose()
  }

  createProductService() {
    let {
      itemType,
      productServiceStore,
      productServiceStore: {
        productService: {
          object
        }
      }
    } = this.props;

    if(itemType === 'Materials'){
      object.product_service_type = 'Products (Non-inventory)';
    }else{
      object.product_service_type = 'Service';
    }

    if (!this.validateName(object)) {
      return;
    }

    productServiceStore.create()
      .then(this.onSuccessfullyCreateProductService.bind(this))
      .catch(this.onFailCreateProductService.bind(this))
  }

  onSuccessfullyCreateProductService(response) {
    this.props.productServiceStore.productService.object = {} // so the next Add starts blank
    this.props.onSuccess()
    Toast.show({ message: "Product/Service created successfully.", intent: Intent.SUCCESS })
  }

  onFailCreateProductService(error) {
    if(error.response && error.response.data && error.response.data.errors) {
      Toast.show({ message: error.response.data.errors, intent: Intent.DANGER })
    } else {
      Toast.show({ message: "Something went wrong. Failed to create/update product/service.", intent: Intent.DANGER })
    }
  }

  updateProductService() {
    let {
      itemType,
      productServiceStore,
      productServiceStore: {
        productService: {
          object
        }
      }
    } = this.props;

    if(itemType === 'Materials'){
      object.product_service_type = 'Products (Non-inventory)';
    }else{
      object.product_service_type = 'Service';
    }

    if (!this.validateName(object)) {
      return;
    }
    
    productServiceStore.update()
      .then(this.onSuccessfullyUpdateProductService.bind(this))
      .catch(this.onFailCreateProductService.bind(this))
  }

  onSuccessfullyUpdateProductService(response) {
    this.props.productServiceStore.productService.object = {} // so the next Add starts blank
    this.props.onSuccess()
    Toast.show({ message: "Product/Service updated successfully.", intent: Intent.SUCCESS })
  }

  openXeroProductServiceModal() {
    let { 
      xeroStore,
      productServiceStore: {
        productService: {
          object
        }
      },
     } = this.props;
     

    if(object.code === "" || object.code == null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid code!', intent: Intent.DANGER })
      return;
    }else{
      this.props.xeroStore.xeroItem.object.code = object.code;
    }

    if(object.name === "" || object.name == null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid name!', intent: Intent.DANGER })
      return;
    }else{
      this.props.xeroStore.xeroItem.object.name = object.name;
    }

    if(object.description === "" || object.description == null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid description!', intent: Intent.DANGER })
      return;
    }else{
      this.props.xeroStore.xeroItem.object.description = object.description;
    }

    xeroStore.createProductService()
      .then(this.onSuccessfullyCreateXeroItem.bind(this))
      .catch(this.onFailCreateXeroItem.bind(this))
    //this.isItemsXeroDialogVisible = true;
    //this.props.xeroStore.loadXeroItems()
  }

  // Adding the item to Xero (separate from creating the product/service, whose
  // handlers above these used to be overwritten by these same-named methods).
  onSuccessfullyCreateXeroItem(response) {
    this.props.xeroStore.loadXeroItems();
    Toast.show({ message: "Items created successfully.", intent: Intent.SUCCESS })
  }

  onFailCreateXeroItem(error) {
    if(error.response && error.response.data && error.response.data.errors) {
      Toast.show({ message: error.response.data.errors, intent: Intent.DANGER })
    } else {
      Toast.show({ message: "Something went wrong. Failed to create/update items", intent: Intent.DANGER });
    }
  }

  handleServiceTypeChange(event) {
    let {
      productServiceStore: {
        productService: {
          object
        }
      }
    } = this.props;
    object.product_service_type = event.target.value;
  }

  handleNameChange(event){
    let {
      productServiceStore: {
        productService: {
          object
        }
      }
    } = this.props;
    object.name = event.target.value;
    object.code = event.target.value;
    this.clearError('name');
  }

  @action
  onSupplierSelect(supplier) {
    let {
      props: {
        viewStore: {
          productServiceSearch,
          productServiceSearch: {
            where: {
              supplier_id,
              ...whereWithNoClientId
            }
          }
        }
      }
    } = this;

    let {
      productServiceStore: {
        productService: {
          object
        }
      }
    } = this.props;

    if (supplier) { 
      this.props.viewStore.productServiceSearch = {
        ...productServiceSearch,
        where: {
          ...productServiceSearch.where,
          supplier_id: supplier.id
        }
      }
      object.supplier_id = supplier.id;
    } else {
      this.props.viewStore.productServiceSearch = {
        ...productServiceSearch,
        where: {
          ...whereWithNoClientId,
          supplier_id: null
        }
      }
      object.supplier_id = '';
    }
    
  }

  @action
  onCategorySelect(category) {
    let {
      props: {
        viewStore: {
          productServiceSearch,
          productServiceSearch: {
            where: {
              product_category_id,
              ...whereWithNoClientId
            }
          }
        }
      }
    } = this;

    let {
      productServiceStore: {
        productService: {
          object
        }
      }
    } = this.props;

    if (category) { 
      this.props.viewStore.productServiceSearch = {
        ...productServiceSearch,
        where: {
          ...productServiceSearch.where,
          product_category_id: category.id
        }
      }
      object.product_category_id = category.id;
    } else {
      this.props.viewStore.productServiceSearch = {
        ...productServiceSearch,
        where: {
          ...whereWithNoClientId,
          product_category_id: null
        }
      }
      object.product_category_id = '';
    }
  }

  render() {
    let {
      edit,
      itemType,
      showItemTypeSelector,
      onChangeItemTypeSelector,
      productServiceStore: {
        productService: {
          isLoading,
          object
        }
      },
      quickbooksStore: {
        quickbooksItems: {
          objects
        }
      },
      xeroStore: {
        xeroItems,
        xeroItem
      }
    } = this.props;
    const busy = !!isLoading;
    const close = this.handleCloseDailog.bind(this);
    const errors = this.errors;
    const hasQuickbooks = !!(objects && objects.length > 0);
    const hasXero = !!(xeroItems && xeroItems.objects && xeroItems.objects.length > 0);
    const kindLabel = itemType === 'Materials' ? 'material' : itemType === 'Labor' ? 'labor' : 'product or service';

    return(
      <div>
        <FormDrawer
          title={edit ? "Edit product or service" : "New product or service"}
          icon={edit ? "edit" : "box"}
          isOpen={this.props.isOpen}
          onClose={close}
          busy={busy}
          footer={
            <>
              <Button text="Cancel" onClick={close} disabled={busy} />
              {edit ?
                <Button
                  intent={Intent.PRIMARY}
                  icon="floppy-disk"
                  text="Save changes"
                  loading={busy}
                  onClick={this.updateProductService.bind(this)}
                />
                :
                <Button
                  intent={Intent.PRIMARY}
                  icon="add"
                  text={`Create ${kindLabel}`}
                  loading={busy}
                  onClick={this.createProductService.bind(this)}
                />
              }
            </>
          }
        >
          { showItemTypeSelector ?
            <Choice
              label="What are you adding?"
              name="Type of item"
              value={itemType || ''}
              options={ITEM_TYPES}
              onChange={(value) => onChangeItemTypeSelector({ target: { value } })}
            /> : null
          }

          <FormSection
            title={itemType === 'Labor' ? 'Labor' : itemType === 'Materials' ? 'Material' : 'Item'}
            hint="How it appears on estimates, work orders and invoices."
          >
            <FormGroup
              className={errors.name ? 'has-error' : undefined}
              label="Name"
              labelFor="product-service-name"
              labelInfo="*"
            >
              <input
                id="product-service-name"
                type='text'
                className='bp3-input bp3-fill'
                placeholder={itemType === 'Labor' ? 'e.g. Service technician' : 'e.g. 16x25x1 air filter'}
                defaultValue={object.name}
                aria-invalid={!!errors.name}
                onChange={this.handleNameChange.bind(this)}
              />
              <FieldError>{errors.name}</FieldError>
            </FormGroup>

            <FormGroup label="Description" labelFor="product-service-description">
              <input
                id="product-service-description"
                type='text'
                className='bp3-input bp3-fill'
                placeholder={itemType === 'Labor' ? 'e.g. Standard hourly labor' : 'e.g. Pleated, MERV 8'}
                defaultValue={object.description || ""}
                onChange={(event) => { object.description = event.target.value } }
              />
            </FormGroup>
          </FormSection>

          { object && itemType === 'Materials' ?
            <FormSection title="Supplier and price" hint="Where you buy it and what you charge.">
              <div className="row">
                <div className="col-6">
                  <FormGroup label="Supplier">
                    <SupplierAutocomplete
                      selectedSupplierId={object && object.supplier_id}
                      onSupplierSelect={this.onSupplierSelect.bind(this)}
                    />
                  </FormGroup>
                </div>
                <div className="col-6">
                  <FormGroup label="Part number" labelFor="product-service-part-number">
                    <input
                      id="product-service-part-number"
                      type='text'
                      className='bp3-input bp3-fill'
                      placeholder='e.g. FLT-16251'
                      defaultValue={object.part_number}
                      onChange={(event) => { object.part_number = event.target.value } }
                    />
                  </FormGroup>
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <FormGroup label={`Unit price (${currency()}${currencySymbol()})`} labelFor="product-service-unit-price">
                    <input
                      id="product-service-unit-price"
                      type='number'
                      step="any"
                      inputMode="decimal"
                      className='bp3-input bp3-fill'
                      placeholder='e.g. 12.50'
                      defaultValue={object.unit_price}
                      onChange={(event) => { object.unit_price = event.target.value } }
                    />
                  </FormGroup>
                </div>
                <div className="col-6">
                  <FormGroup label="Markup" labelFor="product-service-markup">
                    <input
                      id="product-service-markup"
                      type='number'
                      step="any"
                      inputMode="decimal"
                      className='bp3-input bp3-fill'
                      placeholder='e.g. 25'
                      defaultValue={object.mark_up}
                      onChange={(event) => { object.mark_up = event.target.value } }
                    />
                  </FormGroup>
                </div>
              </div>
            </FormSection>
            : null
          }

          { itemType === 'Labor' ?
            <FormSection title="Price" hint="What you charge per hour.">
              <div className="row">
                <div className="col-6">
                  <FormGroup label={`Hourly rate (${currency()}${currencySymbol()})`} labelFor="product-service-hourly-rate">
                    <input
                      id="product-service-hourly-rate"
                      type='number'
                      step="any"
                      inputMode="decimal"
                      className='bp3-input bp3-fill'
                      placeholder='e.g. 95.00'
                      defaultValue={object.unit_price}
                      onChange={(event) => { object.unit_price = event.target.value } }
                    />
                  </FormGroup>
                </div>
                <div className="col-6">
                  <FormGroup label="Markup" labelFor="product-service-markup">
                    <input
                      id="product-service-markup"
                      type='number'
                      step="any"
                      inputMode="decimal"
                      className='bp3-input bp3-fill'
                      placeholder='e.g. 0'
                      defaultValue={object.mark_up}
                      onChange={(event) => { object.mark_up = event.target.value } }
                    />
                  </FormGroup>
                </div>
              </div>
            </FormSection>
            : null
          }

          {(hasQuickbooks || hasXero) &&
            <MoreOptions
              label="Accounting"
              count={(hasQuickbooks ? 1 : 0) + (hasXero ? 1 : 0)}
              open={!isBlank(object.quickbooks_item_id) || !isBlank(object.xero_item_id)}
            >
              {hasQuickbooks ?
                <FormGroup label="QuickBooks product or service" labelFor="quickbooks-item">
                  <div className="bp3-select bp3-fill">
                    <select
                      id="quickbooks-item"
                      value={object.quickbooks_item_id || ''}
                      onChange={event => {
                        object.quickbooks_item_id = event.target.value;
                      }}
                    >
                      <option value="">Choose a QuickBooks product or service</option>
                      {objects.map((item, index) => {
                        return(
                          <option value={item.id} key={`${item.id}-${index}`}>{item.name}</option>
                        )
                      })}
                    </select>
                  </div>
                </FormGroup>
                : null
              }

              {hasXero ?
                <FormGroup label="Xero product or service" labelFor="xero-item">
                  <div className="bp3-select bp3-fill">
                    <select
                      id="xero-item"
                      value={object.xero_item_id || ''}
                      onChange={event => {
                        object.xero_item_id = event.target.value;
                      }}
                    >
                      <option value="">Choose a Xero product or service</option>
                      {xeroItems.objects.map((item, index) => {
                        return(
                          <option value={item.ItemID} key={`${item.ItemID}-${index}`}>{item.Name}</option>
                        )
                      })}
                    </select>
                  </div>
                  <Button
                    className="mt-2"
                    small={true}
                    icon="add"
                    loading={xeroItem.isLoading}
                    onClick={this.openXeroProductServiceModal.bind(this)}
                  >
                    Add to Xero
                  </Button>
                </FormGroup>
                : null
              }
            </MoreOptions>
          }
        </FormDrawer>
        <ProductServiceXeroModal 
          isOpen={this.isItemsXeroDialogVisible} 
          title={"Add Items to Xero"}
          onClose={this.onCloseItemsXeroDialog.bind(this)}
          onSuccess={this.onSucessUpdateItemsXero.bind(this)}
        />
      </div>
    )
  }

}

export default ProductServiceModal;
